<template>
    <Card dis-hover :bordered="false" class="layout">
        <m-query :formData="formData" @onSubmit="onSubmit" :needValidation="settings.needValidation"></m-query>
        <div>
            <div slot="button" style="margin-bottom:10px">
                <Button type="primary" @click="onRowAdd" :loading="loading">新增</Button>
                <Button type="primary" @click="saveOrUpdateData" :loading="loading" :disabled="selection.length === 0" style="margin-left: 10px;">保存
                </Button>
            </div>
            <Table :columns="columns" :data="tableData" :loading="loading" height="400" stripe highlight-row border @on-selection-change="onSelectionChange" ref="table"></Table>
        </div>
    </Card>
</template>
<script>
import mQuery from '@/components/awesome/page/query/index';
import axios from 'axios';

export default {
    components: {
        mQuery,
    },
    data() {
        return {
            selection: [],
            loading: false,
            formData: {
                row: 1,
                items: [
                    {
                        value: '',
                        field: 'interfaceCode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            type: 'text',
                            rows: 1,
                        },
                        type: 'text',
                        title: this.$t('InterfaceSynchronizeView.interfaceCode'),
                    },
                    {
                        value: '',
                        field: 'lastPushDate',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            type: 'datetimerange',
                            format: 'yyyy-MM-dd HH:mm:ss',
                            rows: 1,
                        },
                        type: 'datePicker',
                        title: this.$t('InterfaceSynchronizeView.lastPushDate'),
                        style: 'width:100%;',
                    },
                    {
                        value: '',
                        field: 'interfaceDesc',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            type: 'text',
                            rows: 1,
                        },
                        type: 'text',
                        title: this.$t('InterfaceSynchronizeView.interfaceDesc'),
                    },
                ],
            },
            settings: {
                needPager: false,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [100],
                needSearch: true,
                needValidation: true,
            },
            columns: [
                {
                    title: '选择',
                    type: 'selection',
                    width: 30,
                    align: 'center',
                },
                {
                    title: this.$t('MaterialToolRefMgnView.seq'),
                    type: 'index',
                    minWidth: 50,
                    align: 'center'
                },
                {
                    renderHeader: (h, params) => {
                        return h('div', [
                            h('Label', {
                                style: {
                                    color: 'red',
                                    padding: '5px'
                                }
                            }, '*'),
                            h('span', {
                                style: {
                                    padding: '5px'
                                }
                            }, this.$t('InterfaceSynchronizeView.interfaceCode'))
                        ]);
                    },
                    title: this.$t('InterfaceSynchronizeView.interfaceCode'),
                    key: 'interfaceCode',
                    align: 'center',
                    minWidth: 180,
                    render: (h, params) => {
                        let span = h('span', params.row.interfaceCode);
                        let that = this;
                        let input = h('Input', {
                            props: {
                                value: params.row.interfaceCode,
                                type: 'text',
                                disabled: !!params.row.id
                            },
                            on: {
                                'on-blur': (event) => {
                                    if (params.row.interfaceCode) {
                                        that.$refs['table']['objData'][params.index]['_isChecked'] = true;
                                    }
                                    params.row.interfaceCode = event.target.value;
                                    that.tableData[params.index] = params.row;
                                },
                                'on-change': (event) => {
                                    if (!that.$refs['table']['objData'][params.index]['_isChecked']) {
                                        that.$refs['table']['objData'][params.index]['_isChecked'] = true;
                                        params.row.interfaceCode = event.target.value;
                                        that.selection.push(params.row);
                                    }
                                    params.row.interfaceCode = event.target.value;
                                    that.tableData[params.index] = params.row;
                                    console.log('that.selection:', that.selection);
                                }
                            }
                        });
                        if (params.row.id) {
                            return span;
                        } else {
                            return input;
                        }
                    }
                },
                {
                    title: this.$t('InterfaceSynchronizeView.lastPushDate'),
                    key: 'lastPushDate',
                    transfer: true,
                    align: 'center',
                    minWidth: 160,
                    render: (h, params) => {
                        let that = this;
                        return h('DatePicker', {
                            props: {
                                value: params.row.lastPushDate,
                                type: 'datetime',
                                format: 'yyyy-MM-dd HH:mm:ss',
                                placement: 'bottom',
                                options: {
                                    disabledDate() {}
                                }
                            },
                            style: 'width: 98%',
                            on: {
                                'on-change': (date) => {
                                    params.row.lastPushDate = date;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                {
                    title: this.$t('InterfaceSynchronizeView.leadTime'),
                    key: 'leadTime',
                    align: 'center',
                    minWidth: 120,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.leadTime,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.leadTime = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                {
                    title: this.$t('InterfaceSynchronizeView.batchQuantity'),
                    key: 'batchQuantity',
                    align: 'center',
                    minWidth: 85,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.batchQuantity,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.batchQuantity = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                {
                    title: '步幅',
                    key: 'syncIntervalTime',
                    align: 'center',
                    minWidth: 85,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.syncIntervalTime,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.syncIntervalTime = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    },
                },
                {
                    title: this.$t('InterfaceSynchronizeView.interfaceDesc'),
                    key: 'interfaceDesc',
                    align: 'center',
                    minWidth: 400,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.interfaceDesc,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.interfaceDesc = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                {
                    title: 'attribute1',
                    key: 'attribute1',
                    align: 'center',
                    minWidth: 85,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.attribute1,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.attribute1 = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    },
                },
                {
                    title: 'attribute2',
                    key: 'attribute2',
                    align: 'center',
                    minWidth: 85,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.attribute2,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.attribute2 = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    },
                },
                {
                    title: 'attribute3',
                    key: 'attribute3',
                    align: 'center',
                    minWidth: 85,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.attribute3,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.attribute3 = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    },
                },
                {
                    title: 'attribute4',
                    key: 'attribute4',
                    align: 'center',
                    minWidth: 85,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.attribute4,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.attribute4 = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    },
                },
                {
                    title: 'attribute5',
                    key: 'attribute5',
                    align: 'center',
                    minWidth: 85,
                    render: (h, params) => {
                        let that = this;
                        return h('Input', {
                            props: {
                                value: params.row.attribute5,
                                type: 'text'
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.attribute5 = event.target.value;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    },
                },
                {
                    title: '同步时间',
                    key: 'syncDate',
                    align: 'center',
                    minWidth: 130,
                },
                {
                    title: this.$t('InterfaceSynchronizeView.enabledFlag'),
                    key: 'enabledFlag',
                    align: 'center',
                    minWidth: 60,
                    render: (h, params) => {
                        let that = this;
                        return h('Checkbox', {
                            props: {
                                value: params.row.enabledFlag,
                                trueValue: 'Y',
                                falseValue: 'N'
                            },
                            on: {
                                'on-change': (selection) => {
                                    params.row.enabledFlag = selection;
                                    that.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
            ],
            tableData: [],
            isQueryData: false,
            vendorId: null,
        };
    },
    methods: {
        onSubmit(condition) {
            // debugger;
            // console.log('condition=', condition.lastPushDate.split(','));
            this.loading = true;
            this.selection = [];
            this.tableData = [];
            this.isQueryData = true;
            const date = condition.lastPushDate.split(',');
            axios.post('/gscint/interfaceSynchronize/queryList', {
                pageSize: 10,
                page: 1,
                vendorId: this.vendorId,
                interfaceCode: condition.interfaceCode,
                lastPushDateStart: date[0] ? date[0] : '',
                lastPushDateEnd: date[1] ? date[1] : '',
                interfaceDesc: condition.interfaceDesc
            })
                .then(res => {
                    if (res.data.success === true) {
                        this.tableData = res.data.data.records;
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: res.data.msg
                        });
                    }
                }).catch(() => {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onRowAdd() {
            // debugger;
            if (this.loading === true) {
                return;
            }

            if (this.isQueryData) {
                this.selection = [];
                this.tableData = [];
                this.isQueryData = false;
            }

            this.tableData.push({
                id: '',
                interfaceCode: '',
                lastPushDate: '',
                leadTime: '',
                batchQuantity: '',
                interfaceDesc: '',
            });
        },
        saveOrUpdateData() {
            if (this.loading === true) {
                return;
            }
            this.saveOrUpdateInterfaceSynchronize();
        },
        onSelectionChange(selection) {
            this.selection = selection;
        },
        saveOrUpdateInterfaceSynchronize() {
            let jsonWareVendorRelationship = [];
            let len = this.tableData.length;
            if (len === 0) {
                this.$Message.success(this.$t('MaterialToolRefMgnView.emptyData1'));
                return;
            }
            let url = '';
            if (this.isQueryData) {
                url = '/gscint/interfaceSynchronize/update';
                let uniqCodes = [];
                this.selection.map((item) => {
                    uniqCodes.push(item.interfaceCode);
                });
                let obj = null;
                for (let i = 0; i < len; i++) {
                    obj = this.tableData[i];
                    if (uniqCodes.includes(obj.interfaceCode)) {
                        jsonWareVendorRelationship.push({
                            id: obj.id,
                            interface_code: obj.interfaceCode,
                            last_push_date: obj.lastPushDate,
                            lead_time: obj.leadTime,
                            batch_quantity: obj.batchQuantity,
                            interface_desc: obj.interfaceDesc,
                            enabled_flag: obj.enabledFlag,
                            sync_interval_time: obj.syncIntervalTime,
                            attribute1: obj.attribute1,
                            attribute2: obj.attribute2,
                            attribute3: obj.attribute3,
                            attribute4: obj.attribute4,
                            attribute5: obj.attribute5,
                            last_update_date: obj.lastUpdateDate,
                        });
                    }
                }
            } else {
                let _obj = this.$refs['table']['objData'];
                let ob = null;
                Object.values(_obj).forEach((val, index) => {
                    if (val._isChecked === true) {
                        ob = this.tableData[index];
                        jsonWareVendorRelationship.push({
                            interface_code: ob.interfaceCode,
                            last_push_date: ob.lastPushDate,
                            lead_time: ob.leadTime,
                            batch_quantity: ob.batchQuantity,
                            interface_desc: ob.interfaceDesc,
                            enabled_flag: ob.enabledFlag,
                            sync_interval_time: ob.syncIntervalTime,
                            attribute1: ob.attribute1,
                            attribute2: ob.attribute2,
                            attribute3: ob.attribute3,
                            attribute4: ob.attribute4,
                            attribute5: ob.attribute5,
                        });
                    }
                });
                let msg = '';
                jsonWareVendorRelationship.forEach(el => {
                    if (!el.interface_code.trim()) {
                        msg = '接口编码不能为空';
                    }
                });
                if (msg) {
                    this.$Message.error('接口编码不能为空');
                    return false;
                }
                url = '/gscint/interfaceSynchronize/save';
            }
            this.loading = true;
            axios.post(url, {
                jsonWareVendorRelationship: JSON.stringify(jsonWareVendorRelationship),
                vendorId: this.vendorId,
            })
                .then(res => {
                    this.loading = false;
                    if (res.data.success === true) {
                        if (res.data.data.success === true) {
                            if (this.isQueryData) {
                                this.$Message.success(this.$t('common.update_success'));
                            } else {
                                this.$Message.success(this.$t('common.save_success'));
                                this.tableData = [];
                            }
                        }
                    } else {
                        this.$Message.error(res.data.errorCode);
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
        },
    },
    mounted() {
        this.getUserBaseInfo(({ vendorId }) => {
            this.vendorId = vendorId;
        });
    },
};
</script>
